import { X } from "@phosphor-icons/react";
import { motion } from "motion/react";
import { useEffect } from "react";
import ReactFocusLock from "react-focus-lock";

const MotionFocusLock = motion.create(ReactFocusLock);

const MotionX = motion.create(X);

export const GameMenu: React.FC<{
  children: React.ReactNode;
  onClose: () => void;
}> = ({ children, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <MotionFocusLock
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, pointerEvents: "none" }}
      className="absolute inset-0 flex bg-black/90 text-white dark:bg-black/60"
    >
      <div className="absolute right-4 top-4">
        <button className="btn btn-square btn-ghost" onClick={onClose}>
          <MotionX
            initial={{ rotate: -90 }}
            animate={{ rotate: 0 }}
            exit={{ rotate: -90 }}
            className="size-8"
            weight="bold"
          />
        </button>
      </div>
      <nav className="m-auto flex flex-col items-center gap-4 md:gap-6">
        {children}
      </nav>
    </MotionFocusLock>
  );
};
